import type { AccessConstraint } from '@sb/shared/access';
import { PlanType } from '@shiftbase-com/ts-shared/models';

/** Access constraints for the kiosk routes. */
export const kioskAccess = {
  kiosk: { permission: ['Manage account'], subscriptionPlan: PlanType.BASIC },
} satisfies Record<string, AccessConstraint>;
